import { JsonLdBuilder } from './seo.models';

/**
 * Reusable schema.org builders. Textual arguments are i18n keys resolved
 * against the active language at render time.
 */

export function webSiteJsonLd(): JsonLdBuilder {
  return ({ baseUrl, config, lang }) => ({
    '@type': 'WebSite',
    name: config.siteName,
    url: `${baseUrl}/`,
    inLanguage: lang,
  });
}

export function organizationJsonLd(): JsonLdBuilder {
  return ({ baseUrl, config }) => ({
    '@type': 'Organization',
    name: config.siteName,
    url: `${baseUrl}/`,
    logo: `${baseUrl}/assets/images/logo.svg`,
  });
}

export function webApplicationJsonLd(options: { nameKey: string; descriptionKey: string; featureKeys?: string[] }): JsonLdBuilder {
  return ({ url, lang, t, config }) => ({
    '@type': 'WebApplication',
    name: t(options.nameKey),
    description: t(options.descriptionKey),
    url,
    inLanguage: lang,
    applicationCategory: 'MultimediaApplication',
    operatingSystem: 'Web',
    browserRequirements: 'Requires JavaScript',
    publisher: { '@type': 'Organization', name: config.siteName, url: `${config.baseUrl}/` },
    offers: { '@type': 'Offer', price: '0', priceCurrency: 'USD' },
    ...(options.featureKeys?.length ? { featureList: options.featureKeys.map(key => t(key)) } : {}),
  });
}

export function faqPageJsonLd(items: { questionKey: string; answerKey: string }[]): JsonLdBuilder {
  return ({ t }) => ({
    '@type': 'FAQPage',
    mainEntity: items.map(item => ({
      '@type': 'Question',
      name: t(item.questionKey),
      acceptedAnswer: { '@type': 'Answer', text: t(item.answerKey) },
    })),
  });
}

export function breadcrumbsJsonLd(items: { nameKey: string; path: string }[]): JsonLdBuilder {
  return ({ baseUrl, lang, config, t }) => ({
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: t(item.nameKey),
      item:
        lang === config.defaultLang
          ? `${baseUrl}${item.path ? `/${item.path}` : '/'}`
          : `${baseUrl}/${lang}${item.path ? `/${item.path}` : ''}`,
    })),
  });
}
